module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/fiscal/fiscal.component.css
// module id = ./src/app/components/fiscal/fiscal.component.css
// module chunks = main